import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';

/** Layout-only: gives the editor routes a "Policies" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/policies')({
  staticData: { crumb: 'common:nav.policies' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.read');
  },
  component: Outlet,
});
